import { Box } from '@mui/material';
import { Typography } from 'src/components/new/Typography';
import AddPAF from './modals/AddPAF';
import { useEffect, useState } from 'react';
import { AppDispatch, RootState } from 'src/store/store';
import { useDispatch, useSelector } from 'react-redux';
import { getPAF, submitPAF } from 'src/features/company/utils';
import { transformIsoDateToUSAFormat } from 'src/utils/utility-functions';
import BkSnackBar from 'src/components/snackbar/BkSnackBar';
import { PafValues } from 'src/features/company/constants';

interface SnackbarProps {
  type: 'success' | 'error';
  msg: string;
}

const PAFSection: React.FC = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const [showSnackbarMsg, setShowSnackbarMsg] = useState<SnackbarProps>({
    msg: '',
    type: 'success',
  });

  const dispatch: AppDispatch = useDispatch();

  const onPAFSubmit = (data: PafValues) => {
    dispatch(submitPAF(data)).then((result) => {
      if (submitPAF.fulfilled.match(result)) {
        dispatch(getPAF());
        setShowSnackbarMsg({ msg: 'Postal Acknowledgment Form submitted successfully', type: 'success' });
      } else {
        setShowSnackbarMsg({ msg: 'Something went wrong', type: 'error' });
      }
      setIsFormOpen(false);
    });
  };

  useEffect(() => {
    dispatch(getPAF());
  }, []);

  const paf = useSelector((state: RootState) => state.company.paf);
  const isPafExpired = paf && paf.expiredAt ? Date.parse(paf.expiredAt) < Date.now() : false;

  return (
    <>
      <BkSnackBar
        open={!!showSnackbarMsg.msg}
        handleCloseSnackbar={() => setShowSnackbarMsg({ type: 'success', msg: '' })}
        snackMessage={showSnackbarMsg.msg}
        severity={showSnackbarMsg.type}
      />
      <Box sx={{ display: 'block', width: 'fit-content', marginTop: 4, marginBottom: 3}}>
        <Typography sx={{ fontSize: '1.5rem', lineHeight: '2.5rem'}} fontWeight={400}>
          Postal Acknowledgment Form
        </Typography>
        <Typography fontSize={11} sx={{marginTop: 1, marginBottom: 2}}>NCOA Link Mail Processing Equipment Acknowledgement Form</Typography>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Box>
            <Typography fontSize={12}>Status</Typography>
            {paf !== null && paf !== undefined && !isPafExpired ? (
              <Typography fontWeight={500}>Active</Typography>
            ) : (
              <Typography
                fontSize={14}
                onClick={() => setIsFormOpen(true)}
                fontWeight={600}
                sx={{ color: '#436eb2', textDecoration: 'underline', cursor: 'pointer' }}
              >
                Activate
              </Typography>
            )}
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'left', flexDirection: 'column' }}>
            <Typography fontSize={12}>Expiration Date</Typography>
            {paf !== null && paf !== undefined ? (
              <Typography fontWeight={500} sx={{ color: isPafExpired ? 'red' : 'inherit'}}>{isPafExpired ? 'Expired' : transformIsoDateToUSAFormat(paf.expiredAt)}</Typography>
            ) : (
              <Typography fontWeight={500}>-</Typography>
            )}
          </Box>
        </Box>
      </Box>
      <AddPAF existingPAFData={paf} onSubmit={onPAFSubmit} open={isFormOpen} onClose={() => setIsFormOpen(false)} />
    </>
  );
};

export default PAFSection;
